import { render } from "./container-details-notes.vue?vue&type=template&id=46b93a37&scoped=true"
import script from "./container-details-notes.vue?vue&type=script&lang=js"
export * from "./container-details-notes.vue?vue&type=script&lang=js"

import "./container-details-notes.vue?vue&type=style&index=0&id=46b93a37&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b93a37"]])

export default __exports__